import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../../../theme';

const { colors, fonts, fontSize, spacing, radius, breakpoints } = redesignTheme;

export const useResultDetailCardStyles = makeStyles(() => ({
  detailCard: {
    display: 'flex',
    flexDirection: 'column',
    borderRadius: radius.sm,
    overflow: 'hidden',
    backgroundColor: colors.white,
  },
  detailCardHeader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 48,
    padding: spacing.xs,
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.base,
    color: colors.white,
    letterSpacing: '1.28px',
    textTransform: 'uppercase',
    textAlign: 'center',
  },
  detailCardBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.sm,
    padding: `${spacing.sm}px ${spacing.md}px ${spacing.sm}px`,
    flex: 1,
  },
  detailCardImage: {
    width: '100%',
    height: 'auto',
    display: 'block',
    objectFit: 'cover',
  },
  detailCardImagePlaceholder: {
    width: '100%',
    minHeight: 200,
    backgroundColor: colors.iconSurface,
    [`@media (min-width: ${breakpoints.tablet}px)`]: {
      minHeight: 280,
    },
  },
  detailCardTitle: {
    margin: 0,
    fontFamily: fonts.opensansBold,
    fontSize: fontSize.md,
    color: colors.textBody,
    lineHeight: 'normal',
    letterSpacing: '0.42px',
  },
  detailCardSubtitle: {
    margin: 0,
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.md,
    color: colors.text,
    lineHeight: 'normal',
    letterSpacing: '0.42px',
  },
  detailCardButton: {
    width: '100%',
    height: 40,
    marginTop: 'auto',
    border: `1px solid ${colors.border}`,
    borderRadius: radius.sm,
    backgroundColor: colors.white,
    color: colors.primaryDark,
    fontFamily: fonts.opensansSemiBold,
    fontSize: fontSize.md,
    letterSpacing: '0.28px',
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: spacing.xs,
    '&:hover': {
      backgroundColor: colors.hoverSurface,
    },
  },
  detailCardArrow: {
    width: 16,
    height: 16,
  },
  detailCardImageWrapper: {
    position: 'relative',
  },
}));
